import React from 'react';
import MathsWhizzInlineDarkEnGb from './cxboqnlD.svg';
import MathsWhizzInlineDarkEnUs from './fwTGGaij.svg';
import MathsWhizzInlineDarkRuRu from './ezCvQXTx.svg';
import MathsWhizzInlineLightEnGb from './bFmQCNLU.svg';
import MathsWhizzInlineLightEnUs from './djGxWtCh.svg';
import MathsWhizzInlineLightRuRu from './fOAprfmG.svg';
import MathsWhizzInlineNoblueDarkEnGb from './dhabZcsu.svg';
import MathsWhizzInlineNoblueDarkEnUs from './cpieQpyX.svg';
import MathsWhizzInlineNoblueDarkRuRu from './eeLobNtK.svg';
import MathsWhizzInlineNoblueLightEnGb from './YPgAmuuq.svg';
import MathsWhizzInlineNoblueLightEnUs from './epvZLxoP.svg';
import MathsWhizzInlineNoblueLightRuRu from './etYYfVeb.svg';
import MathsWhizzInlineNoblueNobylineDarkEnGb from './bQfJWUsq.svg';
import MathsWhizzInlineNoblueNobylineDarkEnUs from './fBXHQDBr.svg';
import MathsWhizzInlineNoblueNobylineDarkRuRu from './fGsgSRrc.svg';
import MathsWhizzInlineNoblueNobylineLightEnGb from './khnIauTl.svg';
import MathsWhizzInlineNoblueNobylineLightEnUs from './zSWOPTKb.svg';
import MathsWhizzInlineNoblueNobylineLightRuRu from './fxAvAKkQ.svg';
import MathsWhizzInlineNobylineDarkEnGb from './bpxULRHc.svg';
import MathsWhizzInlineNobylineDarkEnUs from './cmCmPCDG.svg';
import MathsWhizzInlineNobylineDarkRuRu from './dyBFDedi.svg';
import MathsWhizzInlineNobylineLightEnGb from './cQdqXsmD.svg';
import MathsWhizzInlineNobylineLightEnUs from './bsddsaYz.svg';
import MathsWhizzInlineNobylineLightRuRu from './fjsldiVV.svg';
import MathsWhizzStackedDarkEnGb from './dqfgXHJs.svg';
import MathsWhizzStackedDarkEnUs from './baxcmcjx.svg';
import MathsWhizzStackedDarkRuRu from './cnWqzqzh.svg';
import MathsWhizzStackedLightEnGb from './bNYZXTWb.svg';
import MathsWhizzStackedLightEnUs from './cDEwhnfL.svg';
import MathsWhizzStackedLightRuRu from './daFOeZCs.svg';
import MathsWhizzStackedNoblueDarkEnGb from './cbMGavdj.svg';
import MathsWhizzStackedNoblueDarkEnUs from './bQaBkYWG.svg';
import MathsWhizzStackedNoblueDarkRuRu from './ciLPXwgY.svg';
import MathsWhizzStackedNoblueLightEnGb from './eQuGwYLO.svg';
import MathsWhizzStackedNoblueLightEnUs from './chcMbBxp.svg';
import MathsWhizzStackedNoblueLightRuRu from './fheQmUDk.svg';
import MathsWhizzStackedNoblueNobylineDarkEnGb from './RhHEJvcp.svg';
import MathsWhizzStackedNoblueNobylineDarkEnUs from './fojpgpvf.svg';
import MathsWhizzStackedNoblueNobylineDarkRuRu from './cKfDKjeU.svg';
import MathsWhizzStackedNoblueNobylineLightEnGb from './cYOZDEEk.svg';
import MathsWhizzStackedNoblueNobylineLightEnUs from './fhiTUKmH.svg';
import MathsWhizzStackedNoblueNobylineLightRuRu from './dPLEelZS.svg';
import MathsWhizzStackedNobylineDarkEnGb from './FrsbaOub.svg';
import MathsWhizzStackedNobylineDarkEnUs from './ffImzjgx.svg';
import MathsWhizzStackedNobylineDarkRuRu from './epSVnWlg.svg';
import MathsWhizzStackedNobylineLightEnGb from './ehzaNWnd.svg';
import MathsWhizzStackedNobylineLightEnUs from './bPEWOfnD.svg';
import MathsWhizzStackedNobylineLightRuRu from './BoJLndrU.svg';
import MathsWhizzTutoringPlusDarkEnGb from './edGXoZlC.svg';
import MathsWhizzTutoringPlusDarkEnUs from './cqFFqWhT.svg';
import MathsWhizzTutoringPlusDarkEsMx from './fwZCZUNt.svg';
import MathsWhizzTutoringPlusDarkRuRu from './einaaZup.svg';
import MathsWhizzTutoringPlusDarkSwKe from './bcIyYNDp.svg';
import MathsWhizzTutoringPlusLightEnGb from './fBJXHJrn.svg';
import MathsWhizzTutoringPlusLightEnUs from './fdupvDaM.svg';
import MathsWhizzTutoringPlusLightEsMx from './fzxLTJWH.svg';
import MathsWhizzTutoringPlusLightRuRu from './zkLqQDQX.svg';
import MathsWhizzTutoringPlusLightSwKe from './wUKBLMwc.svg';
import MathsWhizzCube from './ArmxGMgT.svg';
import MathsWhizzCubeNoBlue from './bgtPZqIZ.svg';
import TeachersResourceInlineDarkEnGb from './forERDOL.svg';
import TeachersResourceInlineDarkEnUs from './bRTsWEUl.svg';
import TeachersResourceInlineDarkEsMx from './fCXKjmYW.svg';
import TeachersResourceInlineDarkFrCd from './xhaoAoIb.svg';
import TeachersResourceInlineDarkRuRu from './fvwDUbWB.svg';
import TeachersResourceInlineDarkSwKe from './vTLGSjyc.svg';
import TeachersResourceInlineDarkThTh from './emgjijyf.svg';
import TeachersResourceInlineLightEnGb from './bZUWuXqw.svg';
import TeachersResourceInlineLightEnUs from './fySkMRLM.svg';
import TeachersResourceInlineLightEsMx from './flofEZrT.svg';
import TeachersResourceInlineLightFrCd from './PvKGtLsa.svg';
import TeachersResourceInlineLightRuRu from './bffwgVqH.svg';
import TeachersResourceInlineLightSwKe from './cONTgNPf.svg';
import TeachersResourceInlineLightThTh from './bopoBFxb.svg';
import TeachersResourceStackedDarkEnGb from './bOpfAXIu.svg';
import TeachersResourceStackedDarkEnUs from './esyIOWit.svg';
import TeachersResourceStackedDarkEsMx from './bQOqrLmS.svg';
import TeachersResourceStackedDarkFrCd from './beqLKDmh.svg';
import TeachersResourceStackedDarkRuRu from './cripdVfW.svg';
import TeachersResourceStackedDarkSwKe from './evVQLimA.svg';
import TeachersResourceStackedDarkThTh from './eNGSWerq.svg';
import TeachersResourceStackedLightEnGb from './eRDfoSDg.svg';
import TeachersResourceStackedLightEnUs from './fmDypIjK.svg';
import TeachersResourceStackedLightEsMx from './flFJDnqB.svg';
import TeachersResourceStackedLightFrCd from './fwrgSFbe.svg';
import TeachersResourceStackedLightRuRu from './cpyMOkWH.svg';
import TeachersResourceStackedLightSwKe from './dlllZPUC.svg';
import TeachersResourceStackedLightThTh from './czalIGLw.svg';
import TeachersResourceCube from './emrDSDym.svg';
import WhizzEducationSolidDarkEnGb from './clQMJGjU.svg';
import WhizzEducationSolidLightEnGb from './SUualDYB.svg';
import WhizzEducationTransparentLightEnGb from './bhMnUGQb.svg';
import WhizzEducationTransparentDarkEnGb from './fPuUdqqD.svg';
import MascotSVG from './SxonXwwT.svg';

const map$2 = {
    inline: {
        light: {
            'en-ae': MathsWhizzInlineLightEnGb,
            'en-gb': MathsWhizzInlineLightEnGb,
            'en-ke': MathsWhizzInlineLightEnGb,
            'en-nz': MathsWhizzInlineLightEnGb,
            'en-us': MathsWhizzInlineLightEnUs,
            'es-mx': MathsWhizzInlineLightEnUs,
            'fr-cd': MathsWhizzInlineLightEnGb,
            'sw-ke': MathsWhizzInlineLightEnGb,
            'th-th': MathsWhizzInlineLightEnGb,
            'ru-ru': MathsWhizzInlineLightRuRu,
        },
        dark: {
            'en-ae': MathsWhizzInlineDarkEnGb,
            'en-gb': MathsWhizzInlineDarkEnGb,
            'en-ke': MathsWhizzInlineDarkEnGb,
            'en-nz': MathsWhizzInlineDarkEnGb,
            'en-us': MathsWhizzInlineDarkEnUs,
            'es-mx': MathsWhizzInlineDarkEnUs,
            'fr-cd': MathsWhizzInlineDarkEnGb,
            'sw-ke': MathsWhizzInlineDarkEnGb,
            'th-th': MathsWhizzInlineDarkEnGb,
            'ru-ru': MathsWhizzInlineDarkRuRu,
        },
    },
    'inline-noblue': {
        light: {
            'en-ae': MathsWhizzInlineNoblueLightEnGb,
            'en-gb': MathsWhizzInlineNoblueLightEnGb,
            'en-ke': MathsWhizzInlineNoblueLightEnGb,
            'en-nz': MathsWhizzInlineNoblueLightEnGb,
            'en-us': MathsWhizzInlineNoblueLightEnUs,
            'es-mx': MathsWhizzInlineNoblueLightEnUs,
            'fr-cd': MathsWhizzInlineNoblueLightEnGb,
            'sw-ke': MathsWhizzInlineNoblueLightEnGb,
            'th-th': MathsWhizzInlineNoblueLightEnGb,
            'ru-ru': MathsWhizzInlineNoblueLightRuRu,
        },
        dark: {
            'en-ae': MathsWhizzInlineNoblueDarkEnGb,
            'en-gb': MathsWhizzInlineNoblueDarkEnGb,
            'en-ke': MathsWhizzInlineNoblueDarkEnGb,
            'en-nz': MathsWhizzInlineNoblueDarkEnGb,
            'en-us': MathsWhizzInlineNoblueDarkEnUs,
            'es-mx': MathsWhizzInlineNoblueDarkEnUs,
            'fr-cd': MathsWhizzInlineNoblueDarkEnGb,
            'sw-ke': MathsWhizzInlineNoblueDarkEnGb,
            'th-th': MathsWhizzInlineNoblueDarkEnGb,
            'ru-ru': MathsWhizzInlineNoblueDarkRuRu,
        },
    },
    'inline-noblue-nobyline': {
        light: {
            'en-ae': MathsWhizzInlineNoblueNobylineLightEnGb,
            'en-gb': MathsWhizzInlineNoblueNobylineLightEnGb,
            'en-ke': MathsWhizzInlineNoblueNobylineLightEnGb,
            'en-nz': MathsWhizzInlineNoblueNobylineLightEnGb,
            'en-us': MathsWhizzInlineNoblueNobylineLightEnUs,
            'es-mx': MathsWhizzInlineNoblueNobylineLightEnUs,
            'fr-cd': MathsWhizzInlineNoblueNobylineLightEnGb,
            'sw-ke': MathsWhizzInlineNoblueNobylineLightEnGb,
            'th-th': MathsWhizzInlineNoblueNobylineLightEnGb,
            'ru-ru': MathsWhizzInlineNoblueNobylineLightRuRu,
        },
        dark: {
            'en-ae': MathsWhizzInlineNoblueNobylineDarkEnGb,
            'en-gb': MathsWhizzInlineNoblueNobylineDarkEnGb,
            'en-ke': MathsWhizzInlineNoblueNobylineDarkEnGb,
            'en-nz': MathsWhizzInlineNoblueNobylineDarkEnGb,
            'en-us': MathsWhizzInlineNoblueNobylineDarkEnUs,
            'es-mx': MathsWhizzInlineNoblueNobylineDarkEnUs,
            'fr-cd': MathsWhizzInlineNoblueNobylineDarkEnGb,
            'sw-ke': MathsWhizzInlineNoblueNobylineDarkEnGb,
            'th-th': MathsWhizzInlineNoblueNobylineDarkEnGb,
            'ru-ru': MathsWhizzInlineNoblueNobylineDarkRuRu,
        },
    },
    'inline-nobyline': {
        light: {
            'en-ae': MathsWhizzInlineNobylineLightEnGb,
            'en-gb': MathsWhizzInlineNobylineLightEnGb,
            'en-ke': MathsWhizzInlineNobylineLightEnGb,
            'en-nz': MathsWhizzInlineNobylineLightEnGb,
            'en-us': MathsWhizzInlineNobylineLightEnUs,
            'es-mx': MathsWhizzInlineNobylineLightEnUs,
            'fr-cd': MathsWhizzInlineNobylineLightEnGb,
            'sw-ke': MathsWhizzInlineNobylineLightEnGb,
            'th-th': MathsWhizzInlineNobylineLightEnGb,
            'ru-ru': MathsWhizzInlineNobylineLightRuRu,
        },
        dark: {
            'en-ae': MathsWhizzInlineNobylineDarkEnGb,
            'en-gb': MathsWhizzInlineNobylineDarkEnGb,
            'en-ke': MathsWhizzInlineNobylineDarkEnGb,
            'en-nz': MathsWhizzInlineNobylineDarkEnGb,
            'en-us': MathsWhizzInlineNobylineDarkEnUs,
            'es-mx': MathsWhizzInlineNobylineDarkEnUs,
            'fr-cd': MathsWhizzInlineNobylineDarkEnGb,
            'sw-ke': MathsWhizzInlineNobylineDarkEnGb,
            'th-th': MathsWhizzInlineNobylineDarkEnGb,
            'ru-ru': MathsWhizzInlineNobylineDarkRuRu,
        },
    },
    stacked: {
        light: {
            'en-ae': MathsWhizzStackedLightEnGb,
            'en-gb': MathsWhizzStackedLightEnGb,
            'en-ke': MathsWhizzStackedLightEnGb,
            'en-nz': MathsWhizzStackedLightEnGb,
            'en-us': MathsWhizzStackedLightEnUs,
            'es-mx': MathsWhizzStackedLightEnUs,
            'fr-cd': MathsWhizzStackedLightEnGb,
            'ru-ru': MathsWhizzStackedLightRuRu,
            'sw-ke': MathsWhizzStackedLightEnGb,
            'th-th': MathsWhizzStackedLightEnGb,
        },
        dark: {
            'en-ae': MathsWhizzStackedDarkEnGb,
            'en-gb': MathsWhizzStackedDarkEnGb,
            'en-ke': MathsWhizzStackedDarkEnGb,
            'en-nz': MathsWhizzStackedDarkEnGb,
            'en-us': MathsWhizzStackedDarkEnUs,
            'es-mx': MathsWhizzStackedDarkEnUs,
            'fr-cd': MathsWhizzStackedDarkEnGb,
            'ru-ru': MathsWhizzStackedDarkRuRu,
            'sw-ke': MathsWhizzStackedDarkEnGb,
            'th-th': MathsWhizzStackedDarkEnGb,
        },
    },
    'stacked-noblue': {
        light: {
            'en-ae': MathsWhizzStackedNoblueLightEnGb,
            'en-gb': MathsWhizzStackedNoblueLightEnGb,
            'en-ke': MathsWhizzStackedNoblueLightEnGb,
            'en-nz': MathsWhizzStackedNoblueLightEnGb,
            'en-us': MathsWhizzStackedNoblueLightEnUs,
            'es-mx': MathsWhizzStackedNoblueLightEnUs,
            'fr-cd': MathsWhizzStackedNoblueLightEnGb,
            'sw-ke': MathsWhizzStackedNoblueLightEnGb,
            'th-th': MathsWhizzStackedNoblueLightEnGb,
            'ru-ru': MathsWhizzStackedNoblueLightRuRu,
        },
        dark: {
            'en-ae': MathsWhizzStackedNoblueDarkEnGb,
            'en-gb': MathsWhizzStackedNoblueDarkEnGb,
            'en-ke': MathsWhizzStackedNoblueDarkEnGb,
            'en-nz': MathsWhizzStackedNoblueDarkEnGb,
            'en-us': MathsWhizzStackedNoblueDarkEnUs,
            'es-mx': MathsWhizzStackedNoblueDarkEnUs,
            'fr-cd': MathsWhizzStackedNoblueDarkEnGb,
            'sw-ke': MathsWhizzStackedNoblueDarkEnGb,
            'th-th': MathsWhizzStackedNoblueDarkEnGb,
            'ru-ru': MathsWhizzStackedNoblueDarkRuRu,
        },
    },
    'stacked-noblue-nobyline': {
        light: {
            'en-ae': MathsWhizzStackedNoblueNobylineLightEnGb,
            'en-gb': MathsWhizzStackedNoblueNobylineLightEnGb,
            'en-ke': MathsWhizzStackedNoblueNobylineLightEnGb,
            'en-nz': MathsWhizzStackedNoblueNobylineLightEnGb,
            'en-us': MathsWhizzStackedNoblueNobylineLightEnUs,
            'es-mx': MathsWhizzStackedNoblueNobylineLightEnUs,
            'fr-cd': MathsWhizzStackedNoblueNobylineLightEnGb,
            'sw-ke': MathsWhizzStackedNoblueNobylineLightEnGb,
            'th-th': MathsWhizzStackedNoblueNobylineLightEnGb,
            'ru-ru': MathsWhizzStackedNoblueNobylineLightRuRu,
        },
        dark: {
            'en-ae': MathsWhizzStackedNoblueNobylineDarkEnGb,
            'en-gb': MathsWhizzStackedNoblueNobylineDarkEnGb,
            'en-ke': MathsWhizzStackedNoblueNobylineDarkEnGb,
            'en-nz': MathsWhizzStackedNoblueNobylineDarkEnGb,
            'en-us': MathsWhizzStackedNoblueNobylineDarkEnUs,
            'es-mx': MathsWhizzStackedNoblueNobylineDarkEnUs,
            'fr-cd': MathsWhizzStackedNoblueNobylineDarkEnGb,
            'sw-ke': MathsWhizzStackedNoblueNobylineDarkEnGb,
            'th-th': MathsWhizzStackedNoblueNobylineDarkEnGb,
            'ru-ru': MathsWhizzStackedNoblueNobylineDarkRuRu,
        },
    },
    'stacked-nobyline': {
        light: {
            'en-ae': MathsWhizzStackedNobylineLightEnGb,
            'en-gb': MathsWhizzStackedNobylineLightEnGb,
            'en-ke': MathsWhizzStackedNobylineLightEnGb,
            'en-nz': MathsWhizzStackedNobylineLightEnGb,
            'en-us': MathsWhizzStackedNobylineLightEnUs,
            'es-mx': MathsWhizzStackedNobylineLightEnUs,
            'fr-cd': MathsWhizzStackedNobylineLightEnGb,
            'ru-ru': MathsWhizzStackedNobylineLightRuRu,
            'sw-ke': MathsWhizzStackedNobylineLightEnGb,
            'th-th': MathsWhizzStackedNobylineLightEnGb,
        },
        dark: {
            'en-ae': MathsWhizzStackedNobylineDarkEnGb,
            'en-gb': MathsWhizzStackedNobylineDarkEnGb,
            'en-ke': MathsWhizzStackedNobylineDarkEnGb,
            'en-nz': MathsWhizzStackedNobylineDarkEnGb,
            'en-us': MathsWhizzStackedNobylineDarkEnUs,
            'es-mx': MathsWhizzStackedNobylineDarkEnUs,
            'fr-cd': MathsWhizzStackedNobylineDarkEnGb,
            'ru-ru': MathsWhizzStackedNobylineDarkRuRu,
            'sw-ke': MathsWhizzStackedNobylineDarkEnGb,
            'th-th': MathsWhizzStackedNobylineDarkEnGb,
        },
    },
    'tutoring-plus': {
        light: {
            'en-ae': MathsWhizzTutoringPlusLightEnGb,
            'en-gb': MathsWhizzTutoringPlusLightEnGb,
            'en-ke': MathsWhizzTutoringPlusLightEnGb,
            'en-nz': MathsWhizzTutoringPlusLightEnGb,
            'en-us': MathsWhizzTutoringPlusLightEnUs,
            'es-mx': MathsWhizzTutoringPlusLightEsMx,
            'fr-cd': MathsWhizzTutoringPlusLightEnGb,
            'ru-ru': MathsWhizzTutoringPlusLightRuRu,
            'sw-ke': MathsWhizzTutoringPlusLightSwKe,
            'th-th': MathsWhizzTutoringPlusLightEnGb,
        },
        dark: {
            'en-ae': MathsWhizzTutoringPlusDarkEnGb,
            'en-gb': MathsWhizzTutoringPlusDarkEnGb,
            'en-ke': MathsWhizzTutoringPlusDarkEnGb,
            'en-nz': MathsWhizzTutoringPlusDarkEnGb,
            'en-us': MathsWhizzTutoringPlusDarkEnUs,
            'es-mx': MathsWhizzTutoringPlusDarkEsMx,
            'fr-cd': MathsWhizzTutoringPlusDarkEnGb,
            'ru-ru': MathsWhizzTutoringPlusDarkRuRu,
            'sw-ke': MathsWhizzTutoringPlusDarkSwKe,
            'th-th': MathsWhizzTutoringPlusDarkEnGb,
        },
    },
    cube: {
        light: {
            'en-ae': MathsWhizzCube,
            'en-gb': MathsWhizzCube,
            'en-ke': MathsWhizzCube,
            'en-nz': MathsWhizzCube,
            'en-us': MathsWhizzCube,
            'es-mx': MathsWhizzCube,
            'fr-cd': MathsWhizzCube,
            'ru-ru': MathsWhizzCube,
            'sw-ke': MathsWhizzCube,
            'th-th': MathsWhizzCube,
        },
        dark: {
            'en-ae': MathsWhizzCube,
            'en-gb': MathsWhizzCube,
            'en-ke': MathsWhizzCube,
            'en-nz': MathsWhizzCube,
            'en-us': MathsWhizzCube,
            'es-mx': MathsWhizzCube,
            'fr-cd': MathsWhizzCube,
            'ru-ru': MathsWhizzCube,
            'sw-ke': MathsWhizzCube,
            'th-th': MathsWhizzCube,
        },
    },
    'cube-noblue': {
        light: {
            'en-ae': MathsWhizzCubeNoBlue,
            'en-gb': MathsWhizzCubeNoBlue,
            'en-ke': MathsWhizzCubeNoBlue,
            'en-nz': MathsWhizzCubeNoBlue,
            'en-us': MathsWhizzCubeNoBlue,
            'es-mx': MathsWhizzCubeNoBlue,
            'fr-cd': MathsWhizzCubeNoBlue,
            'ru-ru': MathsWhizzCubeNoBlue,
            'sw-ke': MathsWhizzCubeNoBlue,
            'th-th': MathsWhizzCubeNoBlue,
        },
        dark: {
            'en-ae': MathsWhizzCubeNoBlue,
            'en-gb': MathsWhizzCubeNoBlue,
            'en-ke': MathsWhizzCubeNoBlue,
            'en-nz': MathsWhizzCubeNoBlue,
            'en-us': MathsWhizzCubeNoBlue,
            'es-mx': MathsWhizzCubeNoBlue,
            'fr-cd': MathsWhizzCubeNoBlue,
            'ru-ru': MathsWhizzCubeNoBlue,
            'sw-ke': MathsWhizzCubeNoBlue,
            'th-th': MathsWhizzCubeNoBlue,
        },
    },
};

const MathsWhizzLogo = ({ alt, dark = false, disableBlue = false, disableByline = false, disableText = false, locale = 'en-gb', stacked = false, className, tutoringPlusByline = false, ...rest }) => {
    const shade = dark ? 'dark' : 'light';
    let style = disableText ? 'cube' : tutoringPlusByline ? 'tutoring-plus' : (stacked ? 'stacked' : 'inline');
    if (disableBlue && ['stacked', 'inline', 'cube'].includes(style)) {
        style = style + '-noblue';
    }
    if (disableByline && ['stacked', 'stacked-noblue', 'inline', 'inline-noblue'].includes(style)) {
        style = style + '-nobyline';
    }
    if (!alt) {
        alt = 'Maths-Whizz';
        if (!disableByline) {
            alt += ' by Whizz Education';
        }
    }
    return React.createElement("img", Object.assign({ src: map$2[style][shade][locale], alt: alt, className: className }, rest));
};

const map$1 = {
    inline: {
        light: {
            'en-ae': TeachersResourceInlineLightEnGb,
            'en-gb': TeachersResourceInlineLightEnGb,
            'en-ke': TeachersResourceInlineLightEnGb,
            'en-nz': TeachersResourceInlineLightEnGb,
            'en-us': TeachersResourceInlineLightEnUs,
            'es-mx': TeachersResourceInlineLightEsMx,
            'fr-cd': TeachersResourceInlineLightFrCd,
            'ru-ru': TeachersResourceInlineLightRuRu,
            'sw-ke': TeachersResourceInlineLightSwKe,
            'th-th': TeachersResourceInlineLightThTh,
        },
        dark: {
            'en-ae': TeachersResourceInlineDarkEnGb,
            'en-gb': TeachersResourceInlineDarkEnGb,
            'en-ke': TeachersResourceInlineDarkEnGb,
            'en-nz': TeachersResourceInlineDarkEnGb,
            'en-us': TeachersResourceInlineDarkEnUs,
            'es-mx': TeachersResourceInlineDarkEsMx,
            'fr-cd': TeachersResourceInlineDarkFrCd,
            'ru-ru': TeachersResourceInlineDarkRuRu,
            'sw-ke': TeachersResourceInlineDarkSwKe,
            'th-th': TeachersResourceInlineDarkThTh,
        },
    },
    stacked: {
        light: {
            'en-ae': TeachersResourceStackedLightEnGb,
            'en-gb': TeachersResourceStackedLightEnGb,
            'en-ke': TeachersResourceStackedLightEnGb,
            'en-nz': TeachersResourceStackedLightEnGb,
            'en-us': TeachersResourceStackedLightEnUs,
            'es-mx': TeachersResourceStackedLightEsMx,
            'fr-cd': TeachersResourceStackedLightFrCd,
            'ru-ru': TeachersResourceStackedLightRuRu,
            'sw-ke': TeachersResourceStackedLightSwKe,
            'th-th': TeachersResourceStackedLightThTh,
        },
        dark: {
            'en-ae': TeachersResourceStackedDarkEnGb,
            'en-gb': TeachersResourceStackedDarkEnGb,
            'en-ke': TeachersResourceStackedDarkEnGb,
            'en-nz': TeachersResourceStackedDarkEnGb,
            'en-us': TeachersResourceStackedDarkEnUs,
            'es-mx': TeachersResourceStackedDarkEsMx,
            'fr-cd': TeachersResourceStackedDarkFrCd,
            'ru-ru': TeachersResourceStackedDarkRuRu,
            'sw-ke': TeachersResourceStackedDarkSwKe,
            'th-th': TeachersResourceStackedDarkThTh,
        },
    },
    cube: {
        light: {
            'en-ae': TeachersResourceCube,
            'en-gb': TeachersResourceCube,
            'en-ke': TeachersResourceCube,
            'en-nz': TeachersResourceCube,
            'en-us': TeachersResourceCube,
            'es-mx': TeachersResourceCube,
            'fr-cd': TeachersResourceCube,
            'ru-ru': TeachersResourceCube,
            'sw-ke': TeachersResourceCube,
            'th-th': TeachersResourceCube,
        },
        dark: {
            'en-ae': TeachersResourceCube,
            'en-gb': TeachersResourceCube,
            'en-ke': TeachersResourceCube,
            'en-nz': TeachersResourceCube,
            'en-us': TeachersResourceCube,
            'es-mx': TeachersResourceCube,
            'fr-cd': TeachersResourceCube,
            'ru-ru': TeachersResourceCube,
            'sw-ke': TeachersResourceCube,
            'th-th': TeachersResourceCube,
        },
    },
};

const TeachersResourceLogo = ({ alt = 'Maths-Whizz Teachers\' Resource', dark = false, locale = 'en-gb', stacked = false, disableText = false, ...rest }) => {
    const shade = dark ? 'dark' : 'light';
    const style = disableText ? 'cube' : stacked ? 'stacked' : 'inline';
    return React.createElement("img", Object.assign({ src: map$1[style][shade][locale], alt: alt }, rest));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const map = {
    solid: {
        light: {
            'en-ae': WhizzEducationSolidLightEnGb,
            'en-gb': WhizzEducationSolidLightEnGb,
            'en-ke': WhizzEducationSolidLightEnGb,
            'en-nz': WhizzEducationSolidLightEnGb,
            'en-us': WhizzEducationSolidLightEnGb,
            'es-mx': WhizzEducationSolidLightEnGb,
            'fr-cd': WhizzEducationSolidLightEnGb,
            'ru-ru': WhizzEducationSolidLightEnGb,
            'sw-ke': WhizzEducationSolidLightEnGb,
            'th-th': WhizzEducationSolidLightEnGb,
        },
        dark: {
            'en-ae': WhizzEducationSolidDarkEnGb,
            'en-gb': WhizzEducationSolidDarkEnGb,
            'en-ke': WhizzEducationSolidDarkEnGb,
            'en-nz': WhizzEducationSolidDarkEnGb,
            'en-us': WhizzEducationSolidDarkEnGb,
            'es-mx': WhizzEducationSolidDarkEnGb,
            'fr-cd': WhizzEducationSolidDarkEnGb,
            'ru-ru': WhizzEducationSolidDarkEnGb,
            'sw-ke': WhizzEducationSolidDarkEnGb,
            'th-th': WhizzEducationSolidDarkEnGb,
        },
    },
    transparent: {
        light: {
            'en-ae': WhizzEducationTransparentLightEnGb,
            'en-gb': WhizzEducationTransparentLightEnGb,
            'en-ke': WhizzEducationTransparentLightEnGb,
            'en-nz': WhizzEducationTransparentLightEnGb,
            'en-us': WhizzEducationTransparentLightEnGb,
            'es-mx': WhizzEducationTransparentLightEnGb,
            'fr-cd': WhizzEducationTransparentLightEnGb,
            'ru-ru': WhizzEducationTransparentLightEnGb,
            'sw-ke': WhizzEducationTransparentLightEnGb,
            'th-th': WhizzEducationTransparentLightEnGb,
        },
        dark: {
            'en-ae': WhizzEducationTransparentDarkEnGb,
            'en-gb': WhizzEducationTransparentDarkEnGb,
            'en-ke': WhizzEducationTransparentDarkEnGb,
            'en-nz': WhizzEducationTransparentDarkEnGb,
            'en-us': WhizzEducationTransparentDarkEnGb,
            'es-mx': WhizzEducationTransparentDarkEnGb,
            'fr-cd': WhizzEducationTransparentDarkEnGb,
            'ru-ru': WhizzEducationTransparentDarkEnGb,
            'sw-ke': WhizzEducationTransparentDarkEnGb,
            'th-th': WhizzEducationTransparentDarkEnGb,
        },
    },
};

const WhizzEducationLogo = ({ alt = 'Maths-Whizz by Whizz Education', dark = false, locale = 'en-gb', solid = false, ...rest }) => {
    const shade = dark ? 'dark' : 'light';
    const style = solid ? 'solid' : 'transparent';
    return React.createElement("img", Object.assign({ src: map[style][shade][locale], alt: alt }, rest));
};

const Mascot = ({ alt = 'Whizzy', ...rest }) => {
    return React.createElement("img", Object.assign({ src: MascotSVG, alt: alt }, rest));
};

const palette = {
    blue: {
        light: '#0bbbef',
        main: '#009fe3',
        dark: '#002f64',
        contrastText: '#fff',
    },
    green: {
        light: '#a4d534',
        main: '#72b634',
        dark: '#226c0c',
        contrastText: '#fff',
    },
    purple: {
        light: '#bfa3fd',
        main: '#723cfa',
        dark: '#3e28e4',
        contrastText: '#fff',
    },
    red: {
        light: '#fdbcd2',
        main: '#fa3c80',
        dark: '#d10360',
        contrastText: '#fff',
    },
    orange: {
        light: '#fdceba',
        main: '#fa793c',
        dark: '#e0550a',
        contrastText: '#fff',
    },
    yellow: {
        light: '#fef7de',
        main: '#face3c',
        dark: '#f9a900',
        contrastText: '#615324',
    },
};

const fontFamily = '"Nunito Sans",sans-serif';
const theme = {
    typography: {
        fontFamily,
        fontWeightMedium: 700,
    },
    palette: {
        primary: palette.blue,
        secondary: palette.green,
        error: palette.red,
    },
    custom: {
        palette,
        typography: {
            numerics: {
                fontFamily: `Khand,${fontFamily}`,
            },
        },
    },
    overrides: {
        MuiButton: {
            root: {
                transition: 'color .01s',
            },
        },
        MuiTypography: {
            root: {
                transition: 'color .01s',
            },
        },
    },
};

export { Mascot, MathsWhizzLogo, TeachersResourceLogo, WhizzEducationLogo, theme as muiTheme, palette };
